// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1dnAV","tab":"ProcedureTabs_tab__1330y"};